import { Box } from '@mui/material';
import CurriculumItem from '@/components/curriculum/curriculum-item';
import type { Course } from '@/types';

export default function Curriculum({
  course,
  indentation,
  hasMembership,
}: {
  course: Course;
  indentation?: boolean;
  hasMembership: boolean;
}) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      {course.curriculum.map((chapter) => (
        <CurriculumItem
          key={chapter.id}
          chapter={chapter}
          hasMembership={hasMembership}
          indentation={indentation}
        />
      ))}
    </Box>
  );
}
